











































import { mapMutations, mapActions, mapGetters } from 'vuex'
import mixins from 'vue-typed-mixins'
import AmataTabs from '@/components/AmataTabs.vue'
import AmataTabsItem from '@/components/AmataTabsItem.vue'
import AmataCWUserList from '@/components/AmataCWUserList.vue'
import AmataCWUserListItem from '@/components/AmataCWUserListItem.vue'
import PullRefresh from '@/components/PullRefresh.vue'
import Spinner from '@/components/Spinner.vue'
import CallMixin from '@/mixins/CallMixin'
import ScrollMixin from '@/mixins/ScrollMixin'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'
import UserActionMixin from '@/mixins/UserActionMixin'
import { versionCompare, sleep } from '@/utils/helpers'

export default mixins(CallMixin, ScrollMixin, UserActionMixin, VirtualScrollMixin).extend({
  name: 'FootprintList',
  mixins: [CallMixin, UserActionMixin],
  components: {
    AmataTabs,
    AmataTabsItem,
    'amata-cwuser-list': AmataCWUserList,
    'amata-cwuser-list-item': AmataCWUserListItem,
    PullRefresh,
    Spinner
  },
  data() {
    return {
      initialized: false,
      activeTab: this.$store.getters['Footprint/type'] || 0,
      fetchPayload: {
        url: '/footprint/',
        params: {}
      },
      isLoading: false,
      isRefreshing: false
    }
  },
  computed: {
    ...mapGetters('Footprint', [
      'enabledInfinite',
      'entries',
      'distance',
      'type',
      'footprintNum',
      'myFootprintNum'
    ]),

    tabItems(): any[] {
      return [{ type: 0, label: this.footprintLabel }, { type: 1, label: this.myFootprintLabel }]
    },

    itemSize(): number {
      return 96
    },

    footprintLabel(): string {
      return `あしあと(${this.footprintNum})`
    },

    myFootprintLabel(): string {
      return `MYあしあと(${this.myFootprintNum})`
    },

    selectedType(): string {
      if (this.isFootprintType) {
        return 'other'
      } else if (this.isMyFootprintType) {
        return 'my'
      }
      return ''
    },

    listLabel(): string {
      return this.isFootprintType
        ? 'あなたのプロフにアクセスした方です'
        : this.isMyFootprintType
        ? 'あなたがプロフにアクセスした方です'
        : ''
    },

    isFootprintType(): boolean {
      return this.activeTab === 0
    },

    isMyFootprintType(): boolean {
      return this.activeTab === 1
    }
  },
  watch: {
    activeTab(index: number) {
      this.setType(this.tabItems[index].type)
      window.scrollTo(0, 0)
      this.fetchPayload.params['p'] = 0
      this.fetchPayload.params['type'] = this.selectedType
      this.fetchData()
    }
  },
  beforeRouteEnter(_to, from, next) {
    next((vm: any) => {
      if (from.name !== 'user' || vm.entries.length === 0) {
        vm.fetchData()
      }
    })
  },
  created() {
    this.fetchPayload.params = {
      p: 0,
      page: 'get_init',
      type: this.selectedType
    }
    if (this.entries.length === 0) {
      this.fetchData()
    }

    this.$root.$on('routerViewKeyChange', this.resetData)
  },
  async mounted() {
    await this.$nextTick()

    // window に無限スクロールをセット
    this.$_setHandleScroll(1000, this.handleInfinite)

    await sleep(1000)
    this.initialized = true
  },
  destroyed() {
    this.$root.$off('routerViewKeyChange', this.resetData)
  },
  methods: {
    ...mapMutations('Footprint', [
      'clearEntries',
      'setFootprintNum',
      'setMyFootprintNum',
      'setSavedPosition',
      'setSavedPosition',
      'setType'
    ]),
    ...mapActions('Footprint', ['getEntries', 'infinite']),

    /**
     * entries を空にすることをトリガーにしてデータをリセットする
     */
    resetData() {
      this.fetchPayload.params['p'] = 0
      this.clearEntries()
    },

    /**
     * getEntries では無視される entries 以外のデータを処理
     */
    async fetchData() {
      const data = await this.getEntries(this.fetchPayload)
      if (data) {
        if (data.footprint_num) {
          this.setFootprintNum(parseInt(data.footprint_num, 10))
        }
        if (data.my_footprint_num) {
          this.setMyFootprintNum(parseInt(data.my_footprint_num, 10))
        }
      }
    },

    /**
     * 無限スクロール
     */
    async handleInfinite(this: any) {
      if (this.isLoading || !this.enabledInfinite) {
        return
      }
      this.isLoading = true
      await this.infinite({
        fetchPayload: this.fetchPayload
      })
      this.isLoading = false
    },

    /**
     * refresh
     */
    async onRefresh() {
      if (this.isRefreshing) return

      this.isRefreshing = true
      this.fetchPayload.params['p'] = null
      await this.fetchData()
      if (this.$refs.banner) {
        await this.$refs.banner['fetchData']()
      }
      await this.$nextTick()
      this.isRefreshing = false
    },

    /**
     * アクティブなタブを右にずらす
     */
    handleSwipeLeft() {
      if (this.activeTab === this.tabItems.length - 1) {
        this.activeTab = 0
        return
      }
      this.activeTab += 1
    },

    /**
     * アクティブなタブを左にずらす
     */
    handleSwipeRight() {
      if (this.activeTab === 0) {
        this.activeTab = this.tabItems.length - 1
        return
      }
      this.activeTab -= 1
    }
  }
})
